export const intraDayMarketMenuName = 'Menu::MenuG:IntraDay';
